module.exports = __webpack_public_path__ + "static/img/TL.9ec18820.svg";